//请自行添加语言资源
const customerCarrier = {

  msg:{

  }
};
export default customerCarrier



// WEBPACK FOOTER //
// ./src/page/md/customerCarrier/lang/customerCarrier.zh.js